export const EXERCISE_TYPE = {
  MISC: 'misc',
  THEORY: 'theory',
  CRAFTED: 'crafted',
  TRAINING: 'training',
  CORE: 'core',
}